// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file user_confirmation_result_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file user_confirmation_result_type.proto.
 */
export const file_user_confirmation_result_type: GenFile = /*@__PURE__*/
  fileDesc("CiN1c2VyX2NvbmZpcm1hdGlvbl9yZXN1bHRfdHlwZS5wcm90bxIGZG9tYWluKpwBChpVc2VyQ29uZmlybWF0aW9uUmVzdWx0VHlwZRImCiJVU0VSX0NPTkZJUk1BVElPTl9SRVNVTFRfVFlQRV9PUEVOEAASKgomVVNFUl9DT05GSVJNQVRJT05fUkVTVUxUX1RZUEVfQUNDRVBURUQQARIqCiZVU0VSX0NPTkZJUk1BVElPTl9SRVNVTFRfVFlQRV9SRUpFQ1RFRBACQlIKGmFwcC5oZXlsb2dpbi5hbmRyb2lkLnByb3RvWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiogIDSFBBYgZwcm90bzM");

/**
 * @generated from enum domain.UserConfirmationResultType
 */
export enum UserConfirmationResultType {
  /**
   * @generated from enum value: USER_CONFIRMATION_RESULT_TYPE_OPEN = 0;
   */
  OPEN = 0,

  /**
   * @generated from enum value: USER_CONFIRMATION_RESULT_TYPE_ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: USER_CONFIRMATION_RESULT_TYPE_REJECTED = 2;
   */
  REJECTED = 2,
}

/**
 * Describes the enum domain.UserConfirmationResultType.
 */
export const UserConfirmationResultTypeSchema: GenEnum<UserConfirmationResultType> = /*@__PURE__*/
  enumDesc(file_user_confirmation_result_type, 0);

